<template src="./index.html">
</template>
<script>
	import {
		getdata
	} from './data.js'
	import {
		sysYhsSm
	} from "../../../../../../api/Draftgeneration.js"
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
				tableDatadls: [],
				dlsdiag: false,
				yhssm: [],
				headDatadls: getdata().headDatadls,
				pagination: getdata().pagination,
				tableDataZhans: []
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {
			this.$nextTick(() => {
				this.yhs()
			})
		},
		watch: {
			tableData() {
				this.yhs()

			}
		},
		methods: {
			yhs() {
				this.pagination.total = this.tableData.length;
				if (this.tableData.length > this.pagination.pageSize) {
					let data = []
					for (var i = 0; i < this.pagination.pageSize; i++) {
						data.push(this.tableData[i])
					}
					this.tableDataZhans = JSON.parse(JSON.stringify(data))
				} else {
					this.tableDataZhans = JSON.parse(JSON.stringify(this.tableData))
				}
			},
			tableDataSjcl(pageSize, pageNum) {
				let TheNumberOfEnds = pageNum * pageSize //结束的条数
				let TheNumberOfStarts = TheNumberOfEnds-pageSize //开始的条数
				let data = []
				if (this.tableData.length < TheNumberOfEnds) {
					TheNumberOfEnds = this.tableData.length
				}
				for (let i = TheNumberOfStarts; i < TheNumberOfEnds ; i++) {
					data.push(this.tableData[i])
				}
				this.tableDataZhans = JSON.parse(JSON.stringify(data))
			},
			//显示条数
			sizechange(e) {
				this.pagination.pageSize = e;
				this.tableDataSjcl(this.pagination.pageSize, this.pagination.pageNum)
			},
			//显示页码
			currentChange(e) {
				this.pagination.pageNum = e;
				this.tableDataSjcl(this.pagination.pageSize, this.pagination.pageNum)
			},
			forseeMore(index) {
				this.tableDatadls = this.tableData[index].tableDatadls || []
				this.dlsdiag = true
			},
			inputblur(e) {
				this.$emit("inputblur", e)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			forpz() {
				if (this.showpz) {
					this.$emit("forpz", "")
				}
			},

		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>